module.exports = __webpack_public_path__ + "static/img/login_bg.76693b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login_bg.png
// module id = 9LSc
// module chunks = 37